import {createAction, props} from '@ngrx/store';
import {CommerceErrorInterface} from './commerce-error';

export const uncaughtError = createAction(
  '[Error Handling] Unhandled error',
  props<{error: CommerceErrorInterface}>(),
);

export const unrecoverableError = createAction(
  '[Error Handling] Unrecoverable error',
  props<{error: CommerceErrorInterface}>(),
);

export const logError = createAction(
  '[Error Handling] Caught error',
  props<{error: unknown}>(),
);

export const silentOidcAttemptError = createAction(
  '[Error Handling] Silent OIDC attempt error',
  props<{error: CommerceErrorInterface}>(),
);
